(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    const loox = JSON.parse(section.querySelector(".productLooxJSON").textContent);

    // trigger option selection (when coming from url with a specific variant)
    if (urlParams.has("variant")) {
        section.querySelector(`.productV5ProductOptionLabel[data-variant-id="${urlParams.get("variant")}"]`)?.click();
    }

    // update the automatic refill based on url param
    if (urlParams.get("type") === "otp" && section.querySelector(".productV5SubscriptionInput")) {
        section.querySelector(".productV5SubscriptionInput").checked = false;
    }

    // product image swiper
    const productSwiper = new Swiper(section.querySelector(".productV5Swiper"), {
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        pagination: {
            el: section.querySelector(".productV5SwiperPagination"),
            clickable: true,
        },
    });

    // swipe across the dots to move through the slides
    const productPagination = section.querySelector(".productV5SwiperPagination");

    function scrubToPointer(event) {
        const bullets = Array.from(productPagination.querySelectorAll(".swiper-pagination-bullet"));
        const distances = bullets.map(bullet => {
            const rect = bullet.getBoundingClientRect();
            return Math.abs(event.clientX - (rect.left + rect.width / 2));
        });
        const index = distances.indexOf(Math.min(...distances));
        if (index !== productSwiper.activeIndex) productSwiper.slideTo(index);
    }

    productPagination.addEventListener("pointerdown", function (event) {
        this.setPointerCapture(event.pointerId);
        scrubToPointer(event);
    });

    productPagination.addEventListener("pointermove", function (event) {
        if (this.hasPointerCapture(event.pointerId)) scrubToPointer(event);
    });

    // jump to the matching slide when a thumbnail is clicked
    section.querySelectorAll(".productV5Thumbnail").forEach(function (thumbnail) {
        thumbnail.addEventListener("click", function () {
            productSwiper.slideTo(parseInt(this.dataset.slideIndex, 10));
        });
    });

// faq toggle
    section.querySelectorAll('.productV5FaqTop').forEach(el => {
        let parent = el.closest('.productV5Faq');
        el.addEventListener('click', function () {
            this.classList.toggle('active');
            parent.querySelector('.productV5FaqBottom').classList.toggle('active');
        });
    });

    // Function to get the currently active variant based on selected options
    function getActiveVariant() {
        const checkedInputs = section.querySelectorAll(`.productV5ProductOptionInput:checked`);

        // default variant only — no option inputs rendered
        if (checkedInputs.length === 0) {
            return product.variants[0];
        }

        const options = Array.from(checkedInputs).map(input => input.value);
        return product.variants.find((variant) => JSON.stringify(variant.options) === JSON.stringify(options));
    }

    // function to get IF the form is selected to subscribe
    function isSubscription() {
        return section.querySelector(".productV5SubscriptionInput:checked") !== null;
    }

    // Function to update product prices and savings
    function updateProduct() {
        const activeVariant = getActiveVariant();
        const isAutomaticRefill = section.querySelector(".productV5SubscriptionInput:checked");

        let realPrice = activeVariant.price;
        let comparePrice = activeVariant.compare_at_price;

        // Hardcoded check for 1 Month Supply
        if (activeVariant.title.includes("1 Month") && isAutomaticRefill) {
            comparePrice = activeVariant.price;
        }

        // The prices will be based on the selling plan prices if automatic refill is checked and the variant has selling plans
        if (activeVariant.selling_plan_allocations.length > 0) {
            realPrice = isAutomaticRefill ? activeVariant.selling_plan_allocations[0].per_delivery_price : activeVariant.price;
        }

        // Calculate Savings
        let savings = Math.round(((comparePrice - realPrice) / comparePrice) * 100);
        if (savings === 8) {
            savings = 10;
        }

        // Update savings
        section.querySelector(".productV5PriceSave").textContent = savings > 0 ? `${savings}% OFF` : "";

        // Update Price
        section.querySelector(".productV5Price").classList.toggle("sale", savings > 0);
        section.querySelector(".productV5PriceCompare").textContent = (comparePrice !== null && comparePrice > realPrice) ? price(comparePrice) : "";
        section.querySelector(".productV5PriceReal").textContent = price(realPrice);

        // Update each option saving box
        section.querySelectorAll(".productV5ProductOptionLabel").forEach(function (option) {
            // Find associated variant from options
            const variant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify([option.querySelector("input").value]);
            });

            const isAutomaticRefill = isSubscription();

            let realPrice = variant.price;
            let comparePrice = variant.compare_at_price;

            // The prices will be based on the selling plan prices if automatic refill is checked and the variant has selling plans
            if (variant.selling_plan_allocations.length > 0) {
                realPrice = isAutomaticRefill ? variant.selling_plan_allocations[0].per_delivery_price : variant.price;
            }

            // Hardcoded check for 1 Month Supply
            if (variant.title.includes("1 Month") && !variant.compare_at_price && isAutomaticRefill) {
                comparePrice = variant.price;
            }

            // Calculate savings
            let savings = Math.round(((comparePrice - realPrice) / comparePrice) * 100);

            if (savings === 8 || savings === 9) {
                savings = 10;
            }

            // Update Price
            option.querySelector(".productV5ProductOptionPricesReal").textContent = price(realPrice);
            option.querySelector(".productV5ProductOptionPricesCompare").textContent = (comparePrice !== null && comparePrice > realPrice) ? price(comparePrice) : "";
            option.querySelector(".productV5ProductOptionLabelTextNameSavings").textContent = savings > 0 ? `${savings}% OFF` : "";
        });
    }

    // Automatic Refill
    section.querySelector(".productV5SubscriptionInput")?.addEventListener("change", function () {
        section.classList.toggle("subscription", this.checked);
        updateProduct();
    });

    // Option Change Listeners
    section.querySelectorAll(".productV5ProductOptionInput").forEach(function (optionInput) {
        optionInput.addEventListener("change", function () {
            updateProduct();
        });
    });

    // initial update
    updateProduct();

    // add to cart
    section.querySelector(".productV5ATC").addEventListener("click", async function () {
        this.classList.add("loading");

        // get active variant
        const activeVariant = getActiveVariant();

        let formData = {
            quantity: 1,
            id: activeVariant.id,
        };

        // add selling plan id if automatic refill is selected
        if (isSubscription()) {
            formData.selling_plan = activeVariant.selling_plan_allocations[0].selling_plan_id;
        }

        // add to cart
        await addProduct(formData);

        // open cart
        await openCart();

        this.classList.remove("loading");
    });

    // smooth scroll to product section
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(`.button[href="#"]`).forEach(button => button.addEventListener("click", function (event) {
            event.preventDefault();

            section.querySelector(".productV5Content").scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }));

        document.querySelectorAll(`a[href="#product"]`).forEach(link => link.addEventListener("click", function (event) {
            event.preventDefault();

            section.querySelector(".productV5Content").scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }));
    });

    // ------------------------------------------------------
    // Structured Data - JSON-LD
    // ------------------------------------------------------

    const priceValidUntil = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0];

    const shippingDetails = {
        "@type": "OfferShippingDetails",
        "deliveryTime": {
            "@type": "ShippingDeliveryTime",
            "handlingTime": {
                "@type": "QuantitativeValue",
                "minValue": 1,
                "maxValue": 3,
                "unitCode": "d"
            },
            "transitTime": {
                "@type": "QuantitativeValue",
                "minValue": 4,
                "maxValue": 7,
                "unitCode": "d"
            }
        },
        "shippingDestination": {
            "@type": "DefinedRegion",
            "addressCountry": Shopify.country
        },
        "shippingRate": {
            "@type": "MonetaryAmount",
            "value": "0.00",
            "currency": Shopify.currency.active
        }
    };

    const hasMerchantReturnPolicy = {
        "@type": "MerchantReturnPolicy",
        "url": "https://respire.com/policies/refund-policy",
        "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
        "merchantReturnDays": 30,
        "returnFees": "https://schema.org/FreeReturn",
        "returnMethod": "https://schema.org/ReturnByMail",
        "applicableCountry": Shopify.country
    };

    // build offers for each variant
    const variantOffers = [];

    // loop through variants
    product.variants.forEach((variant, index) => {
        // determine mouth_strips or nose_strips
        const productType = product.title.toLowerCase().includes("nose") ? "nose_strips" : "mouth_strips";
        const packSize = (index === 0) ? 30 : (index === 1) ? 90 : 180;

        // temp for GMC testing
        variantOffers.push({
            "@type": "Offer",
            "url": `https://${location.hostname}${location.pathname}?variant=${variant.id}`,
            "sku": `shopify_US_${product.id}_${variant.id}`,
            "priceCurrency": Shopify.currency.active,
            "price": variant.price / 100,
            "priceValidUntil": priceValidUntil,
            "availability": "https://schema.org/InStock",
            "shippingDetails": shippingDetails,
            "hasMerchantReturnPolicy": hasMerchantReturnPolicy
        });

        // add offer for one-time purchase
        variantOffers.push({
            "@type": "Offer",
            "url": `https://${location.hostname}${location.pathname}?variant=${variant.id}&type=otp`,
            "sku": `${productType}_${packSize}_otp`,
            "priceCurrency": Shopify.currency.active,
            "price": variant.price / 100,
            "priceValidUntil": priceValidUntil,
            "availability": "https://schema.org/InStock",
            "shippingDetails": shippingDetails,
            "hasMerchantReturnPolicy": hasMerchantReturnPolicy
        });

        // add offer for subscription if selling plans exist
        if (variant.selling_plan_allocations.length > 0) {
            variantOffers.push({
                "@type": "Offer",
                "url": `https://${location.hostname}${location.pathname}?variant=${variant.id}&type=sub`,
                "sku": `${productType}_${packSize}_sub`,
                "priceCurrency": Shopify.currency.active,
                "price": variant.selling_plan_allocations[0].per_delivery_price / 100,
                "priceValidUntil": priceValidUntil,
                "availability": "https://schema.org/InStock",
                "shippingDetails": shippingDetails,
                "hasMerchantReturnPolicy": hasMerchantReturnPolicy
            });
        }
    });

    // add json-ld
    const jsonLD = {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": product.title,
        "image": product.images.map(img => `https:${img}`),
        "description": (new DOMParser().parseFromString(product.description, 'text/html')).body.textContent || "",
        "offers": variantOffers,
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": loox.avg_rating,
            "reviewCount": loox.num_reviews
        },
        "brand": {
            "@type": "Brand",
            "name": "Respire"
        },
        "gtin13": "781005327155"
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(jsonLD);
    //document.head.appendChild(script);
}());